import React, { FunctionComponent, MouseEventHandler } from 'react';

import { Button as OrbButton, ButtonProps as OrbButtonProps } from '@yandex-360/orb-components/dist/components/Button';
import { ButtonSizeValue } from '@yandex-360/orb-components/dist/components/Button/Button';
import cn from 'classnames';

import { KeyCodes } from '../../helpers/keyboard-keys';
import css from './index.css';

export type ButtonProps = OrbButtonProps & {
    onMouseEnter?: MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
    testId?: string;
    size?: ButtonSizeValue;
};

const Button: FunctionComponent<ButtonProps> = ({ children, size, className, ...buttonProps }) => {
    if (size) {
        return (
            <OrbButton size={size} className={cn(css.important, className)} {...buttonProps}>
                {children}
            </OrbButton>
        );
    }

    return (
        <OrbButton
            pressKeys={[KeyCodes.ENTER]}
            className={cn(css.responsiveButton, css.important, className)}
            {...buttonProps}
        >
            {children}
        </OrbButton>
    );
};

export default Button;
